import React from 'react';
import { useState } from 'react';
import './../../Styles/Header/BurgerMenu.scss'

function BurgerMenu({ setMenuActive, ...props }) {

   //const [isMenuActive, setIsMenuActive] = useState(false);

   const menuActivated = (e) => {
      if (e.closest('#burgerMenu').id === 'burgerMenu') {
         props.menuActive ? setMenuActive(false) : setMenuActive(true);
      }
      
   }

   return (
      <div
         ref={props.menuBurger}
         id='burgerMenu'
         className={props.menuActive ? 'burger__body burger__body-active' : 'burger__body'}
         onClick={e => menuActivated(e.target)}
      >
         <span></span>
      </div>
   );
}
export default BurgerMenu;